import * as  NOTIFICATION_ACTIONS from "./notificationActionTypes";

export const ACCEPT_PROJECT_INVITATION_NOTIFICATION = "App\\Notifications\\AcceptProjectInvitationNotification";
export const REJECT_PROJECT_INVITATION_NOTIFICATION ="App\\Notifications\\RejectProjectInvitationNotification";
export const CHEQUE_NOTIFICATION =  "App\\Notifications\\ChequeNotification";
export const FEED_BACK_NOTIFICATION = "App\\Notifications\\FeedbackNotification";
export const ADVERTISEMENT_NOTIFICATION = "App\\Notifications\\AdvertisementNotification";
export const INVITE_PROJECT_NOTIFICATION = "App\\Notifications\\InviteProjectNotification";
export const UPDATE_BY_OWNER_NOTIFICATION = "App\\Notifications\\UpdateByOwnerNotification";



export default {
  [ACCEPT_PROJECT_INVITATION_NOTIFICATION]: {
    action1: NOTIFICATION_ACTIONS.OK,
    action2: null
  },
  [REJECT_PROJECT_INVITATION_NOTIFICATION]:{
    action1: NOTIFICATION_ACTIONS.OK,
    action2: null
  },
  [CHEQUE_NOTIFICATION]:{
    action1: null,
    action2: NOTIFICATION_ACTIONS.CHANGE_CHEQUE_STATUS
  },
  [FEED_BACK_NOTIFICATION]:{
    action1: NOTIFICATION_ACTIONS.OK,
    action2: NOTIFICATION_ACTIONS.VIEW_ANS
  },
  [ADVERTISEMENT_NOTIFICATION]:{
    action1: NOTIFICATION_ACTIONS.OK,
    action2: NOTIFICATION_ACTIONS.MORE_INFO
  },
  [INVITE_PROJECT_NOTIFICATION]:{
    action1: NOTIFICATION_ACTIONS.REJECT,
    action2: NOTIFICATION_ACTIONS.ACCEPT
  },
  [UPDATE_BY_OWNER_NOTIFICATION]:{
    action1: NOTIFICATION_ACTIONS.OK,
    action2: null
  }

};